import compose from 'recompose/compose';

import DynamicLayout from './DynamicLayout';

import { withModel } from '../../data-providers/model';
import withProductKey from '../../hocs/withProductKey';
import withSetupTracking from '../../hocs/withSetupTracking';
import withProps from 'recompose/withProps';

const enhance = compose(
  withModel,
  withProductKey,
  withSetupTracking,
  withProps(props => ({
    isCheckout: props.model.route.isCheckout,
  }))
);

export default enhance(DynamicLayout);
